import { pick, omit, merge, fromPairs } from "lodash";

import {
  benefitsLoadBegin,
  benefitsLoadSuccess,
  benefitsLoadFailed,
} from "../actions/benefitsActions";

const initialState = {
  benefitSummaries: {},
  fetching: false,
  fetched: false,
  error: null,
};

const optionalFields = ["productSummaryUrl"];
const optionalColumns = ["ProductSummaryUrl"];

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case benefitsLoadBegin:
      return { ...state, fetching: true, error: null };

    case benefitsLoadFailed:
      return { ...state, fetching: false, error: action.payload };
    case benefitsLoadSuccess: {
      // push all optional fields at the end of the structure.
      // Create null entries for those that don't have them.
      const optColumns = action.payload.pageFields.filter(fld =>
        optionalColumns.includes(fld.fieldID)
      );

      const reqColumns = action.payload.pageFields.filter(
        fld => !optionalColumns.includes(fld.fieldID)
      );

      const pageFields = reqColumns.concat(optColumns);

      const benefits = action.payload.benefits.map(benefit => {
        const optionals = pick(benefit, optionalFields);
        const requireds = omit(benefit, optionalFields);
        const forAppend = optionalFields.map(fld => [fld, optionals[fld] || null]);
        return merge(requireds, fromPairs(forAppend));
      });

      // @NOTE hardcode (for 'Disable GTD/UW in Enrolment Statement')
      const uwLettersIdx = pageFields.findIndex(field => field.fieldID === "UwLetters");
      let nextBenefits = [...benefits];
      let nextPageFields = [...pageFields];

      if (uwLettersIdx === -1) {
        nextBenefits = benefits.map(b => {
          b.uwLetters = [];

          return b;
        });

        nextPageFields = [
          ...pageFields,
          {
            displayLabel: "Underwriting Docs and Details",
            displayOrder: benefits.length,
            fieldID: "UwLetters",
            format: "",
            shouldDisplay: false,
            type: "File",
          },
        ];
      }

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        benefitSummaries: {
          ...action.payload,
          benefits: nextBenefits,
          pageFields: nextPageFields,
        },
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/benefitsReducer.jsx